module.exports = __webpack_public_path__ + "img/batch-zh-m.f0e17f06.png";